'use strict';

const constants = {
  SELECT_PROGRAM_ID: '0d772b40-f0ea-4527-b03b-2bd272486364',
  SELECT_ENROLL_SUCCESS_MESSAGE: 'select_enroll_success',
  SELECT_ENROLL_CANCELLED_MESSAGE: 'select_enroll_cancel',
  SELECT_ENROLL_FAILURE_MESSAGE: 'select_enroll_failure',
  SELECT_ENROLL_EXISTING_CARD_SRC: '/programs/select/subscribe_iframe',
  SELECT_ENROLL_ADD_CARD_SRC: '/mybillingrecord/new/select_iframe',
};

module.exports = constants;
